import { JsonValueSchema } from 'notable-common';
import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
export var FlowRunSignalStatus;
(function (FlowRunSignalStatus) {
    FlowRunSignalStatus["Waiting"] = "Waiting";
    FlowRunSignalStatus["Received"] = "Received";
    FlowRunSignalStatus["TimedOut"] = "TimedOut";
})(FlowRunSignalStatus || (FlowRunSignalStatus = {}));
/** A flow run signal as flow-api serves it: `Date` columns are ISO strings. */
export const FlowRunSignalResponseSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime({ offset: true }),
    updated: z.iso.datetime({ offset: true }),
    flowRunId: z.uuid(),
    workflowId: z.string(),
    workflowRunId: z.string(),
    blockId: z.string(),
    signalName: z.string(),
    status: z.enum(FlowRunSignalStatus),
    responsePayload: z.record(z.string(), JsonValueSchema).nullable(),
});
/** Query parameters `GET /flow-runs/signals` accepts. */
export const FlowRunSignalListQuerySchema = z.object({
    flowRunId: z.uuid().describe('Return only signals of this run.').optional(),
    organizationId: z
        .union([z.array(z.uuid()), z.uuid()])
        .describe('Return only signals in this organization, or in any of these organizations.')
        .optional(),
    limit: FlowApiPageLimitSchema.describe('How many signals to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as created.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
    status: z.enum(FlowRunSignalStatus).describe('Return only signals in this status.').optional(),
});
/**
 * Body `POST /flow-executions/signal` accepts.
 *
 * Addresses the workflow carrying out a run rather than a signal row: the caller knows the workflow
 * it is answering, and flow-api resolves which run and organization that is.
 */
export const FlowWorkflowSignalBodySchema = z.object({
    workflowId: z.string().describe('The workflow to signal.'),
    signalName: z.string().describe('Name of the signal the workflow waits on.'),
    payload: z
        .record(z.string(), z.unknown())
        .describe('Value to deliver with the signal.')
        .optional(),
});
//# sourceMappingURL=signal.js.map